export default "__VITE_ASSET__CdovOOHz__"